/* Description opens with a short preview; other information groups stay collapsible. */
if (!customElements.get('mas-product-details')) {
 customElements.define('mas-product-details', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
      this.querySelectorAll('[data-garden-description]').forEach(description => {
        const clip = document.createElement('div');
        const body = document.createElement('div');
        while (description.firstChild) body.append(description.firstChild);
        clip.className = 'mas-pdp-description-clip';
        clip.id = description.closest('details').id + '-description';
        clip.append(body);
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'mas-pdp-description-toggle';
        toggle.textContent = 'Show more';
        toggle.setAttribute('aria-expanded','false');
        toggle.setAttribute('aria-controls',clip.id);
        description.append(clip,toggle);
        let expanded = false;
        const update = () => {
          const long = body.scrollHeight > 344;
          toggle.hidden = !long;
          clip.style.maxHeight = expanded || !long ? 'none' : '320px';
          clip.toggleAttribute('data-collapsed', long && !expanded);
        };
        toggle.addEventListener('click', () => {
          expanded = !expanded;
          toggle.textContent = expanded ? 'Show less' : 'Show more';
          toggle.setAttribute('aria-expanded', String(expanded));
          update();
          if (!expanded) toggle.scrollIntoView({block:'nearest', behavior:'instant'});
        }, {signal:this.controller.signal});
        const observer = new ResizeObserver(update);
        observer.observe(body);
        (this.descriptionObservers ||= []).push(observer);
        (this.descriptionWrappers ||= []).push({description,body,toggle,clip});
        update();
      });
      this.initializeTabs();
  }
  initializeTabs() {
   const tablist = this.querySelector('[data-pdp-tabs]');
   if (!tablist) return;
   this.tabs = [...tablist.querySelectorAll('[data-pdp-tab]')];
   this.panels = [...this.querySelectorAll('[data-pdp-panel]')];
   if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
   const signal = this.controller.signal;
   this.panels.forEach(panel => {
    const tab = this.tabs.find(item => item.dataset.pdpTab === panel.dataset.pdpPanel);
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', tab.id);
    panel.setAttribute('tabindex', '0');
   });
   tablist.addEventListener('click', event => {
    const tab = event.target.closest('[data-pdp-tab]');
    if (tab && this.tabs.includes(tab)) this.activatePanel(tab.dataset.pdpTab);
   }, {signal});
   tablist.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-pdp-tab]');
    const index = this.tabs.indexOf(tab);
    if (index < 0) return;
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = this.tabs.length - 1;
    else return;
    event.preventDefault();
    this.activatePanel(this.tabs[next].dataset.pdpTab, true);
   }, {signal});
   this.activatePanel('care');
   this.revealHash();
   tablist.hidden = false;
   this.setAttribute('data-tabs-ready', '');
   window.addEventListener('hashchange', () => {
    const target = this.revealHash();
    target?.scrollIntoView({block:'start', behavior:'instant'});
   }, {signal});
   this.addEventListener('shopify:block:select', event => this.revealTarget(event.target), {signal});
  }
  activatePanel(name, focus = false) {
   const selected = this.tabs?.find(tab => tab.dataset.pdpTab === name);
   if (!selected) return false;
   this.tabs.forEach(tab => {
    const active = tab === selected;
    tab.setAttribute('aria-selected', String(active));
    tab.tabIndex = active ? 0 : -1;
   });
   this.panels.forEach(panel => { panel.hidden = panel.dataset.pdpPanel !== name; });
   if (focus) selected.focus({preventScroll:true});
   return true;
  }
  revealTarget(target) {
   if (!(target instanceof Element) || !this.contains(target)) return false;
   const panel = target.closest('[data-pdp-panel]');
   if (!panel || !this.activatePanel(panel.dataset.pdpPanel)) return false;
   let disclosure = target.closest('details');
   while (disclosure && this.contains(disclosure)) {
    disclosure.open = true;
    disclosure = disclosure.parentElement?.closest('details');
   }
   return true;
  }
  revealHash() {
   let id;
   try { id = decodeURIComponent(location.hash.slice(1)); } catch (error) { return null; }
   const target = id && document.getElementById(id);
   return this.revealTarget(target) ? target : null;
  }
  disconnectedCallback() {
   this.controller?.abort();
   this.descriptionObservers?.forEach(observer=>observer.disconnect());
   this.descriptionWrappers?.forEach(({description,body,toggle,clip})=>{description.append(...body.childNodes);toggle.remove();clip.remove();});
   this.panels?.forEach(panel => {
    panel.hidden = false;
    panel.removeAttribute('role');
    panel.removeAttribute('aria-labelledby');
    panel.removeAttribute('tabindex');
   });
   const tablist = this.querySelector('[data-pdp-tabs]');
   if (tablist) tablist.hidden = true;
   this.removeAttribute('data-tabs-ready');
   this.tabs = []; this.panels = [];
   this.descriptionObservers=[]; this.descriptionWrappers=[]; this.controller=null;
  }
 });
}
/* Mirror the main purchase controls; submit its form to preserve properties and cart validation. */
if (!customElements.get('mas-product-bar')) {
  customElements.define('mas-product-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.main = this.closest('.hdt-main-section--product');
      if (!this.main) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.button = this.querySelector('[data-bar-add]');
      this.variant = this.querySelector('[data-bar-variant]');
      this.quantity = this.querySelector('[data-bar-quantity]');
      this.minus = this.querySelector('[data-bar-minus]');
      this.plus = this.querySelector('[data-bar-plus]');
      this.error = this.querySelector('[data-bar-error]');
      this.mobile = matchMedia('(max-width: 1199px)');
      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.variant?.addEventListener('change', () => {
        const picker = this.main.querySelector(`hdt-variant-picker[form="${CSS.escape(this.dataset.form)}"]`);
        if (!picker?.masterInput || !picker.selectVariantByID) return;
        picker.removeAttribute('no-pick');
        picker.selectVariantByID(this.variant.value, false);
        this.queue();
      }, {signal});
      this.quantity.addEventListener('change', () => this.setQuantity(this.quantity.value), {signal});
      this.quantity.addEventListener('input', () => {
        if (this.quantity.value !== '') this.setQuantity(this.quantity.value);
      }, {signal});
      this.minus.addEventListener('click', () => this.stepQuantity(-1), {signal});
      this.plus.addEventListener('click', () => this.stepQuantity(1), {signal});
      this.button.addEventListener('click', () => {
        this.update();
        if (!this.submit || this.button.disabled) return;
        if (!this.form.reportValidity()) {
          this.form.querySelector(':invalid')?.scrollIntoView({block:'center'});
          return;
        }
        this.form.requestSubmit(this.submit);
        this.queue();
      }, {signal});
      // Keep references fresh when a product widget replaces its controls.
      const source = this.main.querySelector('.hdt-product-info__list');
      this.observer = new MutationObserver(this.queue);
      this.sizeObserver = new ResizeObserver(this.queue);
      if (source) {
        this.observer.observe(source, {subtree:true,childList:true,characterData:true,attributes:true,
          attributeFilter:['disabled','aria-busy','class','hidden','value','min','max','step']});
        this.sizeObserver.observe(source);
      }
      ['change','input','variant:change','cart:add:error','variant:add'].forEach(type =>
        this.main.addEventListener(type, this.queue, {signal}));
      document.addEventListener('cart:change', this.queue, {signal});
      // IntersectionObserver alone misses jumps from below to above the viewport.
      window.addEventListener('scroll', this.queue, {passive:true,signal});
      window.addEventListener('resize', this.queue, {passive:true,signal});
      window.addEventListener('pageshow', this.queue, {signal});
      this.update();
    }
    get sourceQuantity() { return this.form?.elements.namedItem('quantity'); }
    setQuantity(value) {
      const source = this.sourceQuantity;
      if (!source) return;
      const min = Number(source.min || 1);
      const max = source.max === '' ? Infinity : Number(source.max);
      const step = Number(source.step || 1);
      const parsed = Number(value);
      const valid = Number.isFinite(parsed) && value !== '' ? parsed : min;
      const capped = Math.max(min, Math.min(max, valid));
      source.value = String(min + Math.floor((capped - min) / step) * step);
      source.dispatchEvent(new Event('change', {bubbles:true}));
      this.update();
    }
    stepQuantity(direction) {
      const source = this.sourceQuantity;
      if (source) this.setQuantity(Number(source.value) + direction * Number(source.step || 1));
    }
    update() {
      this.form = document.getElementById(this.dataset.form);
      this.submit = this.form?.querySelector('button[name="add"]');
      this.hidden = !this.submit;
      if (!this.submit) { this.removeAttribute('data-visible'); return; }
      const master = this.form.elements.namedItem('id');
      const busy = this.submit.getAttribute('aria-busy') === 'true' || this.submit.classList.contains('is-loading');
      const picker = this.main.querySelector(`hdt-variant-picker[form="${CSS.escape(this.dataset.form)}"]`);
      if (this.variant) {
        if (master?.value) this.variant.value = master.value;
        this.variant.disabled = busy || !picker?.masterInput;
      }
      const source = this.sourceQuantity;
      this.quantity.closest('[data-bar-quantity-controls]').hidden = !source;
      if (source) {
        for (const attr of ['min','max','step']) {
          const value = source.getAttribute(attr);
          if (value === null) this.quantity.removeAttribute(attr);
          else this.quantity.setAttribute(attr, value);
        }
        if (document.activeElement !== this.quantity) this.quantity.value = source.value;
        this.quantity.disabled = busy || source.disabled || this.submit.disabled;
        this.minus.disabled = this.quantity.disabled || Number(source.value) <= Number(source.min || 1);
        this.plus.disabled = this.quantity.disabled || (source.max !== '' && Number(source.value) >= Number(source.max));
      }
      this.button.disabled = this.submit.disabled || busy || !!master?.disabled;
      this.button.textContent = this.submit.querySelector('.hdt-btn-atc_text')?.textContent.trim() || 'Add to cart';
      this.button.setAttribute('aria-busy', String(busy));
      const error = this.form.querySelector('.hdt-form-message--error:not([hidden]) .hdt-error-message');
      const message = error?.textContent.trim() || '';
      if (this.error.textContent !== message) this.error.textContent = message;
      this.error.hidden = !message;
      const rect = this.submit.getBoundingClientRect();
      this.toggleAttribute('data-visible', this.mobile.matches && rect.height > 0 && rect.bottom <= 0);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.observer?.disconnect();
      this.sizeObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}


/* Resolve links to native description and reviews widgets without duplicating them. */
if (!window.masFreshwaterNavigationReady) {
  window.masFreshwaterNavigationReady = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    let target;
    if (link.dataset.pdpJump === 'description') target = document.querySelector('[data-pdp-description]');
    else {
      let url;
      try { url = new URL(link.href, location.href); } catch (error) { return; }
      if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
      let id;
      try { id = decodeURIComponent(url.hash.slice(1)); } catch (error) { return; }
      target = document.getElementById(id);
    }
    target?.closest('mas-product-details')?.revealTarget?.(target);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('.mas-pdp-navigation [data-pdp-jump]');
    if (!link) return;
    const kind = link.dataset.pdpJump;
    let target;
    if (kind === 'description') target = document.querySelector('[data-pdp-description]');
    if (kind === 'reviews') target = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    if (!target) return;
    event.preventDefault();
    if (target.matches('details')) target.open = true;
    const focusTarget = target.querySelector('summary, h2, h3') || target;
    if (!focusTarget.matches('summary')) focusTarget.setAttribute('tabindex', '-1');
    focusTarget.focus({preventScroll:true});
    target.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
  const updateReviewCount = () => {
    const badge = document.querySelector('.mas-pdp .jdgm-prev-badge[data-number-of-reviews]');
    if (!badge) return;
    const count = Number(badge.dataset.numberOfReviews);
    document.querySelectorAll('[data-pdp-review-count]').forEach(el => {el.textContent = count > 0 ? '(' + count + ')' : '';});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',updateReviewCount,{once:true});
  else updateReviewCount();
  window.addEventListener('load',updateReviewCount,{once:true});
}
